import { useEffect } from "react";

import './WorkItems.css';
import Work from "../../components/Work/Work";

export default function WorkItems() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="page-container">
            <Work isWorkListing={true} />
        </div>
    );
}